// Last reply and Unmatched count for the status strip, from the held reply summary.
import { formatReceived } from './model.js'

function lastReplyItem(held, loading) {
  const base = { key: 'last-reply', tone: 'neutral' }
  if (loading) return { ...base, label: 'Last reply: Checking' }
  if (held?.kind === 'ready') return { ...base, label: held.lastReceivedAt === null ? 'Last reply: None yet' : `Last reply: ${formatReceived(held.lastReceivedAt)}` }
  if (held?.kind === 'notConnected') return { ...base, label: 'Last reply: Not connected yet' }
  return { ...base, label: 'Last reply: Unknown', tone: 'warning' }
}

function unmatchedItem(held, loading) {
  const base = { key: 'unmatched' }
  if (loading) return { ...base, label: 'Unmatched replies: Checking', tone: 'neutral' }
  if (held?.kind === 'ready') return held.held === 0 ? { ...base, label: 'No unmatched replies', tone: 'success' } : { ...base, label: `Unmatched replies: ${held.held}`, tone: 'warning' }
  if (held?.kind === 'notConnected') return { ...base, label: 'Unmatched replies: Not connected yet', tone: 'neutral' }
  return { ...base, label: 'Unmatched replies: Unknown', tone: 'warning' }
}

// `items` is the strip as buildStripModel made it. A viewer sees no mailbox health, so no unmatched count.
export function applyHeldToStrip(items, { role, held, loading = false }) {
  const out = []
  for (const item of items) {
    if (item.key === 'last-reply') {
      out.push(lastReplyItem(held, loading))
      if (role !== 'viewer') out.push(unmatchedItem(held, loading))
    } else out.push(item)
  }
  return out
}
